
import { Route, Routes } from 'react-router-dom'

import { Edit, List } from './components'

export const ModuleRoutes = () => (
  <>
    <List />
    <Routes>
      <Route path=":id" element={<Edit />} />
    </Routes>
  </>
)
